<form [formGroup]="formsControl" class="w-3/4">
  <mat-card>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
      <mat-tab label="Général">
        <mat-divider></mat-divider>
        <mat-card class="m-auto w-3/6">
          <mat-card-header>
            <mat-card-title>
              <h3>Contrôle d'accès</h3>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="flex flex-col">
            <div class="flex justify-between items-baseline">
              <mat-form-field class="large-field">
                <input matInput placeholder="Identifiant" id="username" formControlName="username">
                <mat-error *ngIf="username.invalid">{{getErrorMessage("username")}}</mat-error>
              </mat-form-field>
              <mat-slide-toggle formControlName="enabled" color="primary">Actif</mat-slide-toggle>
            </div>
            <div class="flex justify-between items-baseline">
              <div class="flex flex-col">
                <mat-slide-toggle formControlName="is_anett" (change)="onAnettChange($event.checked)"
                  [disabled]="isAdminDistri()" color="primary">
                  Utilisateur Anett
                </mat-slide-toggle>
                <mat-slide-toggle hideIfNot="ROLE_ADMIN_GLOBAL || ROLE_ADMIN_DISTRI" formControlName="is_admin_site"
                  (change)="onAdminSiteChange($event.checked)" [disabled]="isAdminDistri()" color="primary">
                  Administrateur de site
                </mat-slide-toggle>
                <mat-slide-toggle hideIfNot="ROLE_ADMIN_GLOBAL || ROLE_ADMIN_DISTRI" formControlName="is_agent_distri"
                  (change)="onDistriChange($event.checked)" [disabled]="isAdminDistri()" color="primary">
                  Agent de distribution
                </mat-slide-toggle>
              </div>
              <mat-form-field hideIfNot="ROLE_ADMIN_GLOBAL || ROLE_ADMIN_DISTRI">
                <mat-select placeholder="Site Affectation" id="site_affectation" [compareWith]="compareSite"
                  formControlName="site_affectation">
                  <mat-option></mat-option>
                  <mat-option *ngFor="let site of sites" [value]="site">
                    {{site.numero}} - {{site.region}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="site_affectation.invalid">{{getErrorMessage("site_affectation")}}</mat-error>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="m-auto w-3/6">
          <mat-card-header>
            <mat-card-title>
              <h3>Identité</h3>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="flex flex-col">
            <div class="flex justify-between">
              <mat-form-field>
                <mat-select placeholder="Civilité" [compareWith]="compareCivility" formControlName="civility">
                  <mat-option *ngFor="let civilite of civilities" [value]="civilite">
                    {{civilite.libelle_long}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="civility.invalid">{{getErrorMessage("civility")}}</mat-error>
              </mat-form-field>
            </div>
            <div class="flex justify-between">
              <mat-form-field>
                <input matInput placeholder="Prénom" formControlName="firstname">
                <mat-error *ngIf="firstname.invalid">{{getErrorMessage("firstname")}}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <input matInput placeholder="Nom" formControlName="lastname">
                <mat-error *ngIf="lastname.invalid">{{getErrorMessage("lastname")}}</mat-error>
              </mat-form-field>
            </div>
            <div class="flex justify-between">
              <mat-form-field>
                <input matInput placeholder="Email" formControlName="email">
                <mat-icon matSuffix>email</mat-icon>
                <mat-error *ngIf="email.invalid">{{getErrorMessage("email")}}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <input matInput placeholder="Téléphone" formControlName="phone">
                <mat-icon matSuffix>phone</mat-icon>
                <mat-error *ngIf="phone.invalid">{{getErrorMessage("phone")}}</mat-error>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>
      <mat-tab label="Rôles">
        <mat-divider></mat-divider>
        <div class="column-roles flex justify-center m-auto w-3/6">
          <mat-selection-list (selectionChange)="selectionChange($event)" class="flex-1">
            <mat-list-option [selected]="isSelectedRole(role)" *ngFor="let role of esclivaliableRoles" [value]="role"
              color="primary">
              {{role.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </mat-tab>
      <mat-tab label="Comptes Clients" [disabled]="isUserAnett() || isUserAgentDistri()">
        <mat-divider></mat-divider>
        <div class="flex flex-col">
          <div class="flex gap-5">
            <mat-form-field>
              <mat-select [(value)]="siteFilter.value" (selectionChange)="setSiteFilter($event)">
                <mat-option *ngFor="let site of sites" [value]="site">
                  {{site.numero}} - {{site.region}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="large">
              <mat-label>Numéro Client ou Raison Sociale</mat-label>
              <input matInput [(ngModel)]="groupFilter" [ngModelOptions]="{standalone: true}" (keyup)="updateFilter()">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <div class="flex">
            <div class="tab-container">
              <table mat-table [dataSource]="matInterface">
                <ng-container matColumnDef="client">
                  <th mat-header-cell *matHeaderCellDef> Client </th>
                  <td mat-cell *matCellDef="let client"> {{client.code_client}}/{{client.code_service}} -
                    {{client.raison_sociale}}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let client">
                    <button mat-icon-button (click)="selectGroup(client)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['client','action']; sticky: true"></tr>
                <tr mat-row *matRowDef="let client; columns: ['client','action'];"></tr>
              </table>
            </div>
            <div class="h-full mx-0.5"></div>
            <div class="tab-container">
              <table mat-table [dataSource]="matInterfaceSelected">
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let client">
                    <button mat-icon-button (click)="unselectGroup(client)">
                      <mat-icon>remove</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="site">
                  <th mat-header-cell *matHeaderCellDef> Site </th>
                  <td mat-cell *matCellDef="let client">
                    <ng-container
                      *ngIf="client != undefined && client.site!=undefined">{{client.site.numero}}</ng-container>
                  </td>
                </ng-container>
                <ng-container matColumnDef="client">
                  <th mat-header-cell *matHeaderCellDef> Client </th>
                  <td mat-cell *matCellDef="let client">
                    <ng-container *ngIf="client != undefined">{{client.code_client}}/{{client.code_service}} -
                      {{client.raison_sociale}}</ng-container>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let group; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="submitForm()">Enregistrer</button>
    </mat-card-actions>
  </mat-card>
</form>